import { fetchPosts } from '@/services/userService';
import { parseRelationCodes } from '@/lib/restriction';

export const Single = {
  namespaced: true,
  state: {
    loaded: false,
    data: null,
    isError: null,
    restrictionCodes: null,
  },
  getters: {
    loaded: (state: any) => {
      return state.loaded;
    },
    data: (state: any) => {
      return state.data;
    },
    restrictionCodes: (state: any) => {
      return state.restrictionCodes;
    },
    token: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/token'];
    },
    lang: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/lang'];
    },
  },
  mutations: {
    resetData: (state: any) => {
      state.data = null;
      state.isError = false;
      state.restrictionCodes = null;
    },
    logout: (state: any) => {
      state.loaded = false;
      state.data = null;
      state.isError = false;
      state.restrictionCodes = null;
    },
    setLoaded: (state: any, bool: boolean) => {
      state.loaded = bool;
    },
    setData: (state: any, data: PostData) => {
      state.data = data;
    },
    setError: (state: any, bool: boolean) => {
      state.isError = bool;
    },
    setRestrictionCodes: (state: any, codes: RelationCode[] | null) => {
      state.restrictionCodes = codes;
    },
  },
  actions: {
    getEntry: async (cxt: any, params: any) => {
      cxt.commit('setRestrictionCodes', null);
      const result = await fetchPosts({
        cat: `${params.category}`,
        id: params.id,
        lang: `${cxt.getters.lang}`
      })
      .then( (response) => {
        if (response.datas[0] === undefined) {
          cxt.commit('setData', null);
          cxt.dispatch('head/updateTitle', null, {root: true});
        } else {
          cxt.commit('setData', response.datas[0]);
          cxt.dispatch('head/updateTitle', response.datas[0].title, {root: true});
        }
        cxt.commit('setLoaded', true);
        return response;
      })
      .catch( (e) => {
        console.error(e);
        // 連携条件による 403 の場合は、本文の条件コード（例: "1,2"）を保持する
        if (e.response && e.response.status === 403) {
          cxt.commit('setRestrictionCodes', parseRelationCodes(e.response.data));
        }
        cxt.commit('setData', null);
        cxt.dispatch('head/updateTitle', null, {root: true});
        cxt.commit('setLoaded', true);
        return { hits: '0', datas: [] } as ApiPost;
      });
      return result;
    },
  },
};
